module.exports = __webpack_public_path__ + "static/images/callout_1.a89d031e4eaba73f90875304fc44cf52.jpg";